import { inject, Injectable, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { filter, map, mergeMap } from "rxjs/operators";
import { User } from "../../models/user.model";
import { get as _get, includes as _includes} from "lodash-es";
import { AuthService } from "../auth/auth.service";
import { StoreService } from "../store/store.service";

@Injectable({
  providedIn: "root",
})
export class TrackingService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private router: Router = inject(Router);
  private titleService: Title = inject(Title);
  private store: StoreService = inject(StoreService);
  guestUrls = [ "logout", "login", "register", "forgot-password", "verify-password" ];
  constructor() {}
  init(){
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.router.routerState.root;
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === "primary"),
        mergeMap((route) => route.data),
        map((data: any) => {
          // If 'title' is specified in route data, use it, otherwise use the document title
          return data.title || this.titleService.getTitle();
        })
      )
      .subscribe((title) => {
        if(!_includes(_get(window, 'location.href'), 'login')) {
          const userDetails = this.store.getUser();
          this.trackUser(userDetails)
          this.trackPageView(window?.location?.href, title);
          // console.log('---- TRACKING SERVICE', userDetails, window?.location?.href);
        }
      });
  }

  private trackUser(userDetails: User) {
    let userType = "Registered";
    const currentRoute = _get(this.router, 'url') && _includes(this.router.url, '/') ? this.router.url.slice(1) : _get(this.router, 'url');
    if(_includes(this.guestUrls, currentRoute)) {
      userType = "Guest"
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "track_user_id",
      user_id: _get(userDetails, "userId", null),
      user_type: userType,
      user_role: userDetails ? _get(userDetails, "userRole", "OrganizationAdmin") : null,
      account_plan: userDetails ? "Trial_Plan" : null,
    });
  }

  private trackPageView(url: string, title: string): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtual_pageview",
      page_location: url,
      page_title: title,
    });
  }

  public trackCustomEvent(key: string, data: any){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: key,
      data
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}